export function useDocMeta(title: string, description: string, keywords?: string) {
  const apply = () => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = description;

    if (keywords) {
      let kw = document.querySelector('meta[name="keywords"]') as HTMLMetaElement | null;
      if (!kw) {
        kw = document.createElement('meta');
        kw.name = 'keywords';
        document.head.appendChild(kw);
      }
      kw.content = keywords;
    }
  };
  return apply;
}